<template>
  <VisualHero background-color="bg-green-sell">
    <NuxtImg
      slot="image"
      class="w-full h-full object-cover"
      src="/assets/img/visual/ucrs-visual-valuta-casa.png"
    />
    <template slot="title">
      Valuta casa online: facile, veloce, affidabile
    </template>
    <template slot="description">
      Scopri quanto vale la tua casa e affidati a un Consulente che ti guiderà
      fino alla fine della compravendita.
    </template>
  </VisualHero>
</template>

<script>
// Components
import VisualHero from '~/components/VisualHero.vue'

export default {
  components: {
    VisualHero,
  },
}
</script>
